import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input } from '@angular/core';
import RewardsTrackDTO from 'src/app/cms-v2/entities/rewards-track/dtos/RewardsTrackDTO';
import { CommonEntityService } from 'src/app/common/services/common-entity.service';
import { EndlessOfferService } from 'src/app/common/services/endless-offer.service';
import { LoggerService } from 'src/app/common/services/logger.service';
import { UtilitiesService } from 'src/app/common/services/utilities.service';

@Component({
  selector: 'app-endless-offer-track-v2',
  templateUrl: './endless-offer-track-v2.component.html',
  styleUrls: ['./endless-offer-track-v2.component.css']
})
export class EndlessOfferTrackComponentV2 implements OnInit {

  @Input() eoTrack: RewardsTrackDTO;
  @Input() parentEntity: string;
  public isLoading: boolean = true;
  public envKey: 'dev' | 'qa' | 'prod' | 'test' = this.loadSelectedEnvironment();

  constructor(
    private endlessOfferService: EndlessOfferService,
    private commonEntityService: CommonEntityService,
    private logger: LoggerService,
    private utilities: UtilitiesService,
  ) { }

  async ngOnInit(): Promise<void> {
    if (this.eoTrack?.EOrewards?.length > 0) {
      await this.fetchThumbnailForCredits(this.eoTrack.EOrewards);
    }
    this.isLoading = false;
  }

  loadSelectedEnvironment(): 'dev' | 'qa' | 'prod' | 'test' {
    const savedEnvironment = localStorage.getItem('selectedEnvironment');
    if (savedEnvironment) {
      const environmentObject = JSON.parse(savedEnvironment);
      return environmentObject.value;
    } else {
      return 'dev'
    }
  }

  async fetchThumbnailForCredits(EOrewards: any): Promise<void> {
    const allTasks: (() => Promise<void>)[] = [];

    for (let i = 0; i < EOrewards.length; i++) {
      const creditsArray = EOrewards[i];

      for (let j = 0; j < creditsArray.length; j++) {
        if (creditsArray[j].lineItemType !== 'StoreListingV2') {
          continue;
        }

        const storeListing = creditsArray[j];

        if(storeListing.id?.pricePoint_ref?.[this.envKey])
        {
          // Queue price point fetch
          allTasks.push(async () => {
            try {
              const pricePoint = await this.commonEntityService.findOneWithQuery('price-points', {
                query: { _id: storeListing.id?.pricePoint_ref?.[this.envKey] },
                select: 'id name',
                autopopulate: false
              });
              storeListing.id.pricePoint = pricePoint;
            } catch (err) {
              this.logger.error('Error fetching price point:', err, 'EndlessOfferTrackComponentV2');
            }
          }); 
        }

        if(storeListing.id?.credits_ref?.[this.envKey])
        {
          // Queue each credit fetch
          for (const credit of storeListing.id.credits_ref?.[this.envKey]) 
          {
            allTasks.push(async () => {
              try {
                const controllerName = this.getControllerName(credit.lineItemType);
                const imageSrc = await this.getImageSrc(controllerName, credit.id);
                credit.id.imageSrc = imageSrc;
              } catch (err) {
                this.logger.error('Error fetching credit image:', err, 'EndlessOfferTrackComponentV2');
              }
            });
          } 
        }
      }
    }

    await this.utilities.runWithConcurrency(allTasks, 6);
  }

  getControllerName(type: string): string {
    let controller = 'currencies';
    switch (type) {
      case 'Item':
        controller = 'items';
        break;
      case 'Currency':
        controller = 'currencies';
        break;
      case 'Titles':
        controller = 'titles';
        break;
      case 'SeedPackBox':
        controller = 'seed-pack-box';
        break;
      case 'StoreListingV2':
        controller = 'store-listings-v2';
        break;
      case 'Nurture':
        controller = 'nurtures';
        break;
      default:
        return '#';
    }
    return controller;
  }

  async getImageSrc(controller: string, credit: any): Promise<string> {
    const creditIdData = await this.commonEntityService.findOneWithQuery(controller, {
      query: { _id: credit._id },
      smartPopulate: {
        'image_ref': 'id _id name thumbnails',
        'box_image_ref': 'id _id name thumbnails',
        'thumbnail_ref': 'id _id name thumbnails'
      },
      autopopulate: false
    });

    switch (controller) {
      case 'seed-pack-box':
        return creditIdData?.box_image_ref?.thumbnails[4]?.path;
      case 'items':
        return creditIdData?.thumbnail_ref?.thumbnails[4]?.path;
      default:
        return creditIdData?.image_ref?.thumbnails[4]?.path;
    }
  }

  getLink(type: string, id: string): string {
    let baseUrl = '';
    switch (type) {
      case 'Item':
        baseUrl = '/items';
        break;
      case 'Currency':
        baseUrl = '/currencies';
        break;
      case 'Titles':
        baseUrl = '/titles';
        break;
      case 'SeedPackBox':
        baseUrl = '/seed-pack-box';
        break;
      case 'StoreListingV2':
        baseUrl = '/store-listings-v2';
        break;
      case 'Nurture':
        baseUrl = '/nurture';
        break;
      default:
        return '#';
    }
    return `${baseUrl}/${id}`;
  }
}
